import { __awaiter, __generator } from "tslib";
import { defineComponent, ref, watch, onMounted } from 'vue';
import createHTMLMapMarker from "../../hooks/use-html-map-maker";
import bikeHandler from '@/api-handler/bike';
export default defineComponent({
    name: 'FindBikeMap',
    props: {
        currentPosition: {
            type: Object,
            default: function () { return ({}); }
        },
        searchType: {
            type: String,
            default: ''
        }
    },
    setup: function (props) {
        var _this = this;
        var map = ref(null);
        var center = ref({
            lat: 25.0325917,
            lng: 121.5624999
        });
        var stationsInfo = ref(null);
        var initMap = function () {
            map.value = new window.google.maps.Map(document.getElementById("map"), {
                center: center.value,
                zoom: 15,
                maxZoom: 20,
                minZoom: 3,
                streetViewControl: false,
                mapTypeControl: false,
                disableDefaultUI: true,
            });
        };
        var getNearByBikeStationInfo = function (currentPosition) { return __awaiter(_this, void 0, void 0, function () {
            var lat, lng, nearByAvailabilityBike, nearByStationInfo, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        lat = currentPosition.lat, lng = currentPosition.lng;
                        return [4 /*yield*/, bikeHandler.getNearByAvailabilityBike(lat, lng)];
                    case 1:
                        nearByAvailabilityBike = _a.sent();
                        return [4 /*yield*/, bikeHandler.getNearByStationInfo(lat, lng)];
                    case 2:
                        nearByStationInfo = _a.sent();
                        if (nearByAvailabilityBike && nearByStationInfo) {
                            formatStationInfo(nearByAvailabilityBike.data, nearByStationInfo.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var formatStationInfo = function (nearByAvailabilityBike, nearByStationInfo) {
            stationsInfo.value = nearByAvailabilityBike.reduce(function (result, item) {
                var _a, _b, _c;
                for (var _i = 0, nearByStationInfo_1 = nearByStationInfo; _i < nearByStationInfo_1.length; _i++) {
                    var station = nearByStationInfo_1[_i];
                    if (item.StationUID === station.StationUID) {
                        result.push({
                            availableRentBikes: item.AvailableRentBikes,
                            availableReturnBikes: item.AvailableReturnBikes,
                            lat: (_a = station.StationPosition) === null || _a === void 0 ? void 0 : _a.PositionLat,
                            lng: (_b = station.StationPosition) === null || _b === void 0 ? void 0 : _b.PositionLon,
                            stationName: (_c = station.StationName) === null || _c === void 0 ? void 0 : _c.Zh_tw
                        });
                    }
                }
                return result;
            }, []);
        };
        var setStationMakers = function () {
            var infoWindow = new window.google.maps.InfoWindow({
                pixelOffset: new window.google.maps.Size(0, -20)
            });
            if (stationsInfo.value) {
                stationsInfo.value.map(function (station) {
                    var lat = station.lat, lng = station.lng, availableRentBikes = station.availableRentBikes, availableReturnBikes = station.availableReturnBikes, stationName = station.stationName;
                    var latling = new window.google.maps.LatLng({ lat: lat, lng: lng });
                    var infoContentString = "\n          <div class=\"info-window\">\n            <div class=\"item\">" + stationName + "</div>\n            <div class=\"item\">\u53EF\u501F\u8ECA\u8F1B <span>" + availableRentBikes + "</span></div>\n            <div class=\"item\">\u53EF\u505C\u7A7A\u4F4D <span>" + availableReturnBikes + "</span></div>\n          </div>";
                    if (props.searchType === 'Rent') {
                        var markers_1 = createHTMLMapMarker({
                            latlng: latling,
                            map: map.value,
                            html: "<div class=\"location-count\">\n                <img class=\"locaion-img\" src=\"" + (availableRentBikes === 0 ? 'img/zero.png' : 'img/rent-location.png') + "\">\n                <div class=\"count rent\">" + availableRentBikes + "</div>\n                </div"
                        });
                        window.google.maps.event.addListener(markers_1, "click", function (e) {
                            infoWindow.setContent(infoContentString);
                            infoWindow.open(map, markers_1);
                        });
                    }
                    else if (props.searchType === 'Return') {
                        var markers_2 = createHTMLMapMarker({
                            latlng: latling,
                            map: map.value,
                            html: "<div class=\"location-count\">\n                <img class=\"locaion-img\" src=\"" + (availableReturnBikes === 0 ? 'img/zero.png' : 'img/return-location.png') + "\">\n                <div class=\"count return " + (availableReturnBikes === 0 ? 'zero' : null) + "\">" + availableReturnBikes + "</div>\n                </div"
                        });
                        window.google.maps.event.addListener(markers_2, "click", function (e) {
                            infoWindow.setContent(infoContentString);
                            infoWindow.open(map, markers_2);
                        });
                    }
                });
            }
        };
        watch(function () { return props.currentPosition; }, function (v) { return __awaiter(_this, void 0, void 0, function () {
            var marker;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        center.value = v;
                        initMap();
                        marker = new window.google.maps.Marker({
                            position: v,
                            map: map.value,
                        });
                        return [4 /*yield*/, getNearByBikeStationInfo(v)];
                    case 1:
                        _a.sent();
                        setStationMakers();
                        return [2 /*return*/];
                }
            });
        }); });
        watch(function () { return props.searchType; }, function () {
            setStationMakers();
        });
        onMounted(function () {
            initMap();
        });
        return {
            formatStationInfo: formatStationInfo
        };
    },
});
